/**
 * BNFT Brand Colors Configuration
 *
 * Ce fichier centralise toutes les couleurs de l'application.
 * Modifiez les valeurs ici pour changer les couleurs globalement.
 */

export const brandColors = {
  // Couleur principale - Bleu Navy
  primary: {
    main: '#0d2137',
    light: '#1a365d',
    dark: '#071018',
    contrastText: '#ffffff',
  },

  // Couleur secondaire - Or/Jaune
  secondary: {
    main: '#0077b6',
    light: '#0077b6',
    dark: '#0077b6',
    contrastText: '#ffffff',
  },

  // Couleur d'accent - Rouge
  accent: {
    main: '#c53030',
    light: '#e53e3e',
    dark: '#9b2c2c',
    contrastText: '#ffffff',
  },
} as const;

// Couleurs adaptées pour le mode sombre (plus claires pour la lisibilité)
export const darkModePrimary = {
  main: '#5b8ec9',
  light: '#82b1e0',
  dark: '#3a6fa8',
  contrastText: '#ffffff',
};

export const darkModeSecondary = {
  main: '#4fc3f7',
  light: '#80d8ff',
  dark: '#29b6f6',
  contrastText: '#000000',
};

export const darkModeAccent = {
  main: '#ef5350',
  light: '#ff867c',
  dark: '#e53935',
  contrastText: '#ffffff',
};

// Couleurs de fond pour le mode clair
export const lightBackground = {
  default: '#f8fafc',
  paper: '#ffffff',
};

// Couleurs de fond pour le mode sombre
export const darkBackground = {
  default: '#0a0a0a',
  paper: '#1a1a1a',
};

// Couleurs de texte pour le mode clair
export const lightText = {
  primary: '#1a202c',
  secondary: '#4a5568',
};

// Couleurs de texte pour le mode sombre
export const darkText = {
  primary: '#f7fafc',
  secondary: '#a0aec0',
};

// Export par défaut pour un accès facile
export default brandColors;
